import { DriverInformationBaseDto } from './driver-information-base.dto';

/**
 * DTO object used when returning Driver Information.
 * No validation required as this is intended to used as response.
 * Probably used only internally. In example in PieCloud or `Order Watcher`
 */
export class DriverInformationDto extends DriverInformationBaseDto {
  /** Internal Id in the system. */
  id: number;

  /** Delivery Provider Id stored in the system.   */
  deliveryProviderId: number;

  /** Driver Last name. */
  driverLastName: string;

  /** Driver contact phone number.  */
  driverPhoneNumber: string;
}
